import { render, staticRenderFns } from "./PartnershipDirectoryProfile.vue?vue&type=template&id=8844208c&scoped=true&"
import script from "./PartnershipDirectoryProfile.vue?vue&type=script&lang=js&"
export * from "./PartnershipDirectoryProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8844208c",
  null
  
)

export default component.exports